import SearchBar from '@/atoms/forms/SearchBar';
import useEventAddUserModal from './useEventAddUserModal';
import { FormProvider } from 'react-hook-form';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import Button from '@/atoms/Button';
import { useTranslation } from 'react-i18next';
import ListItem from '@/molecules/ListItem';
import UserLink from '@/atoms/UserLink';

type Props = {
  eventId: string;
  closeModal: () => void;
};
const EventAddUserModal = ({ eventId, closeModal }: Props) => {
  const { handleSubmit, formMethods, data, handleAddUser } = useEventAddUserModal(eventId);
  const { t } = useTranslation();

  return (
    <ModalClassicLayout closeModal={closeModal} title="events.admin.users.addUser">
      <FormProvider {...formMethods}>
        <form className="mb-7" onSubmit={handleSubmit}>
          <SearchBar name="uniqueId" />
        </form>
      </FormProvider>
      {data && (
        <ListItem
          footerProps={{
            children: <Button onClick={handleAddUser}>{t('events.admin.users.modalAdd')}</Button>,
          }}
          headerProps={{
            imageNode: data?.uniqueId && (
              <UserLink
                avatarPath={data?.avatarPath}
                nickName={data?.nickName}
                subLine={data?.uniqueId}
                userUniqId={data?.uniqueId}
              />
            ),
          }}
        />
      )}
      <div className="w-fit mx-auto mt-10">
        <Button onClick={closeModal}>{t('events.admin.users.modalClose')}</Button>
      </div>
    </ModalClassicLayout>
  );
};

export default EventAddUserModal;
